// Create a new file for mock data
export const employeeData = {
  stats: {
    totalEmployees: 248,
    presentToday: 225,
    onLeave: 12,
    openPositions: 8,
    newHires: 5,
    upcomingReviews: 8,
    pendingRequests: 15
  },
  departments: [
    { name: 'Operations', count: 85, budget: 450000 },
    { name: 'Sales', count: 45, budget: 280000 },
    { name: 'IT', count: 38, budget: 320000 },
    { name: 'HR', count: 12, budget: 150000 },
    { name: 'Finance', count: 18, budget: 220000 },
    { name: 'Marketing', count: 25, budget: 180000 },
    { name: 'Support', count: 25, budget: 160000 }
  ],
  recentActivities: [
    {
      id: 1,
      type: 'new_hire',
      employee: 'Sarah Johnson',
      position: 'Senior Developer',
      department: 'IT',
      date: '2024-01-15'
    },
    {
      id: 2,
      type: 'leave_request',
      employee: 'Mohammed Ali',
      status: 'pending',
      duration: '3 days',
      date: '2024-01-14'
    },
    {
      id: 3,
      type: 'review_completed',
      employee: 'Ahmed Hassan',
      rating: 4.5,
      reviewer: 'Fatima Abbas',
      date: '2024-01-13'
    }
  ],
  upcomingEvents: [
    {
      id: 1,
      type: 'review',
      title: 'Performance Review',
      employee: 'Khalid Rahman',
      date: '2024-01-20'
    },
    {
      id: 2,
      type: 'training',
      title: 'Leadership Workshop',
      participants: 12,
      date: '2024-01-22'
    },
    {
      id: 3,
      type: 'onboarding',
      title: 'New Employee Orientation',
      newHires: 3,
      date: '2024-01-25'
    }
  ],
  leaveRequests: [
    {
      id: 1,
      employee: 'Nora Ahmed',
      type: 'Annual Leave',
      duration: '5 days',
      status: 'pending',
      startDate: '2024-02-01'
    },
    {
      id: 2,
      employee: 'Hassan Ali',
      type: 'Sick Leave',
      duration: '2 days',
      status: 'approved',
      startDate: '2024-01-18'
    }
  ],
  recruitmentStats: {
    openPositions: [
      { position: 'Senior Developer', department: 'IT', applications: 28 },
      { position: 'Sales Manager', department: 'Sales', applications: 45 },
      { position: 'HR Specialist', department: 'HR', applications: 32 }
    ],
    hiringStages: {
      screening: 42,
      interview: 18,
      technical: 12,
      offer: 5,
      accepted: 3
    }
  },
  employees: [
    {
      id: 1,
      name: 'Ahmed Hassan',
      position: 'Senior Developer',
      department: 'IT',
      email: 'ahmed.hassan@company.com',
      phone: '+966 50 123 4567',
      location: 'Riyadh HQ',
      status: 'Active',
      joinDate: '2022-03-15'
    },
    {
      id: 2,
      name: 'Fatima Abbas',
      position: 'HR Manager',
      department: 'HR',
      email: 'fatima.abbas@company.com',
      phone: '+966 50 234 5678',
      location: 'Riyadh HQ',
      status: 'Active',
      joinDate: '2021-06-01'
    },
    // Add more employee records...
  ]
};

export const attendanceData = {
  today: {
    present: 225,
    absent: 12,
    late: 8,
    onLeave: 3,
    workingRemote: 15
  },
  trends: [
    { date: '2024-01-10', present: 230, absent: 10, late: 5 },
    { date: '2024-01-11', present: 228, absent: 12, late: 6 },
    { date: '2024-01-12', present: 225, absent: 15, late: 8 },
    { date: '2024-01-13', present: 232, absent: 8, late: 4 },
    { date: '2024-01-14', present: 225, absent: 12, late: 8 }
  ]
};

export const payrollData = {
  monthlySummary: {
    totalSalaries: 1250000,
    benefits: 180000,
    bonuses: 75000,
    deductions: 45000,
    netPayable: 1460000
  },
  departments: [
    { name: 'Operations', amount: 450000, employees: 85 },
    { name: 'Sales', amount: 280000, employees: 45 },
    { name: 'IT', amount: 320000, employees: 38 }
  ],
  recentPayments: [
    {
      id: 1,
      employee: 'Ahmed Hassan',
      amount: 12000,
      type: 'Salary',
      date: '2024-01-01'
    },
    {
      id: 2,
      employee: 'Fatima Abbas',
      amount: 15000,
      type: 'Salary + Bonus',
      date: '2024-01-01'
    }
  ]
};

export const candidatesData = {
  candidates: [
    {
      id: 1,
      name: 'Sarah Johnson',
      position: 'Senior Developer',
      email: 'sarah.j@example.com',
      phone: '+966 50 123 4567',
      department: 'IT',
      status: 'Interview',
      appliedDate: '2024-01-15',
      resume: 'path/to/resume.pdf',
      experience: '8 years',
      skills: ['React', 'Node.js', 'Python', 'AWS'],
      education: 'Master in Computer Science',
      interviews: [
        {
          type: 'Initial Screening',
          date: '2024-01-18',
          interviewer: 'Ahmed Hassan',
          status: 'Completed',
          feedback: 'Strong technical background, good communication skills'
        },
        {
          type: 'Technical Interview',
          date: '2024-01-22',
          interviewer: 'Mohammed Ali',
          status: 'Scheduled'
        }
      ],
      notes: [
        {
          date: '2024-01-15',
          author: 'HR Team',
          content: 'Candidate shows strong potential, fast learner'
        }
      ]
    },
    // Add more candidates...
  ],
  
  trainingCourses: [
    {
      id: 1,
      title: 'Leadership Development',
      description: 'Essential leadership skills for managers',
      instructor: 'Dr. Sarah Johnson',
      duration: '12 weeks',
      startDate: '2024-02-01',
      endDate: '2024-04-30',
      status: 'Upcoming',
      capacity: 30,
      enrolled: 25,
      type: 'Management',
      level: 'Advanced',
      prerequisites: ['Basic Management', 'Team Lead Experience'],
      modules: [
        {
          title: 'Leadership Fundamentals',
          duration: '2 weeks',
          topics: ['Leadership Styles', 'Team Dynamics']
        }
        // Add more modules...
      ],
      assessments: [
        {
          type: 'Quiz',
          weight: 30,
          dueDate: '2024-03-15'
        },
        {
          type: 'Project',
          weight: 70,
          dueDate: '2024-04-25'
        }
      ]
    }
    // Add more courses...
  ],

  employeeTraining: {
    completedCourses: [
      {
        courseId: 1,
        employeeId: 1,
        completionDate: '2023-12-15',
        score: 92,
        certificate: 'path/to/certificate.pdf'
      }
    ],
    inProgress: [
      {
        courseId: 2,
        employeeId: 1,
        startDate: '2024-01-10',
        progress: 45,
        lastAccessed: '2024-01-18'
      }
    ]
  },

  performanceReviews: [
    {
      id: 1,
      employeeId: 1,
      reviewerId: 2,
      period: '2023-Q4',
      date: '2023-12-20',
      status: 'Completed',
      scores: {
        technical: 4.5,
        communication: 4.2,
        teamwork: 4.8,
        leadership: 4.0,
        innovation: 4.3
      },
      feedback: {
        strengths: [
          'Excellent problem-solving skills',
          'Strong team collaboration'
        ],
        improvements: [
          'Can delegate more tasks',
          'Document processes better'
        ]
      },
      goals: [
        {
          title: 'Improve Team Productivity',
          description: 'Increase sprint velocity by 20%',
          deadline: '2024-03-31',
          status: 'In Progress'
        }
      ]
    }
  ]
}; 